import React from 'react';

const CircleDashed = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_2608_11290)">
      <path
        d="M6.5 2.18763C7.4837 1.93225 8.5163 1.93225 9.5 2.18763"
        stroke="#3F3C43"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.21802 6.39389C2.48887 5.41453 3.00516 4.52049 3.71802 3.79639"
        stroke="#3F3C43"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.71802 12.2042C3.00497 11.4798 2.48867 10.5853 2.21802 9.60547"
        stroke="#3F3C43"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 13.8125C8.5163 14.0679 7.4837 14.0679 6.5 13.8125"
        stroke="#3F3C43"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.782 9.60645C13.5111 10.5858 12.9948 11.4798 12.282 12.2039"
        stroke="#3F3C43"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.282 3.79541C12.995 4.51987 13.5113 5.41436 13.782 6.39416"
        stroke="#3F3C43"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2608_11290">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default CircleDashed;
